<template>
  <div class="d-flex justify-content-between flex-wrap">
    <div class="d-flex align-items-center mb-0 mt-1">
      <span class="text-nowrap"> Total de {{ valor.total }} itens </span>
    </div>
    <div>
      <b-pagination
        :value="1"
        :total-rows="valor.total"
        :per-page="quantidade"
        first-number
        last-number
        align="right"
        prev-class="prev-item"
        next-class="next-item"
        class="mt-1 mb-0"
        @input="(value)=>valor.pageChanged({currentPage:value})"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </div>
  </div>
</template>

<style>
</style>

<script>
export default {
  name: 'PaginacaoBase',
  props: {
    valor: {
      type: Object,
      default: () => {},
    },
    quantidade: {
      type: Number,
      default: 10,
    },
  },
}
</script>
